import type { Location, LocationStatus, DealStatus, EquipmentStatus, InstallationStatus, OnboardingStatus } from '@/types/location';

// Mock locations data
export const mockLocations: Location[] = [
  {
    id: 'loc-040',
    location_number: 'LOC-040',
    location_name: 'Lazy River',
    store_name: 'Lazy River',
    status: 'active',
    deal_status: 'active',
    equipment_status: 'equipment_installed',
    installation_status: 'launched_active',
    onboarding_status: 'staff_training_completed',
    address: '149 Broadway Rd, Dracut, MA 01826',
    phone: '(978) 243-9333',
    logo_url: null,
    contract_signed_date: '2024-05-01',
    contract_renewal_date: '2026-05-01',
    contract_term_months: 24,
    contract_signee_name: 'Joe',
    contract_signee_title: 'Owner',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-05-15',
    launch_date: '2024-05-20',
    monthly_license_fee: 1800,
    license_fee_period: 'monthly',
    pos_system: 'Dutchie',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    campaign_start: '2025-02-01',
    campaign_end: '2025-05-31',
    baseline:
      'Feb–May improvement campaign baseline. Post-4/20 window for cleaner comparisons. Family basket lift +14.67% (Dracut) and +10.35% (Tewksbury) in 2025 briefs.',
    case_study_url: '/lazy-river-store-brief-may-2026.html',
    campaign_status: 'complete',
    lifecycle_status: 'active',
    created_at: '2024-04-01T10:00:00Z',
    updated_at: '2026-06-01T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: 'loc-041',
    location_number: 'LOC-041',
    location_name: 'Lazy River Tewksbury',
    store_name: 'Lazy River Tewksbury',
    status: 'active',
    deal_status: 'active',
    equipment_status: 'equipment_installed',
    installation_status: 'launched_active',
    onboarding_status: 'staff_training_completed',
    address: 'Tewksbury, MA',
    phone: null,
    logo_url: null,
    contract_signed_date: '2024-05-01',
    contract_renewal_date: '2026-05-01',
    contract_term_months: 24,
    contract_signee_name: null,
    contract_signee_title: null,
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-05-15',
    launch_date: '2024-05-20',
    monthly_license_fee: 1800,
    license_fee_period: 'monthly',
    pos_system: 'Dutchie',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    campaign_start: null,
    campaign_end: null,
    baseline: null,
    case_study_url: null,
    campaign_status: null,
    lifecycle_status: 'active',
    created_at: '2024-04-01T10:00:00Z',
    updated_at: '2026-06-01T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '1',
    location_number: 'LOC-001',
    location_name: 'Denver Downtown',
    status: 'active',
    deal_status: 'active',
    equipment_status: 'equipment_installed',
    installation_status: 'launched_active',
    onboarding_status: 'staff_training_completed',
    address: '1234 Main Street, Denver, CO 80202',
    phone: '(303) 555-0100',
    logo_url: 'https://cannabis-kiosks.com/wp-content/uploads/2025/11/the-peak-beyond-logo-teal-and-black-icon-small.png',
    contract_signed_date: '2024-01-15',
    contract_renewal_date: '2025-01-15',
    contract_term_months: null,
    contract_signee_name: 'John Smith',
    contract_signee_title: 'Store Manager',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-02-20',
    launch_date: '2024-03-01',
    monthly_license_fee: 2500.00,
    license_fee_period: 'monthly',
    pos_system: 'Dutchie',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-01-10T10:00:00Z',
    updated_at: '2024-11-20T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '2',
    location_number: 'LOC-002',
    location_name: 'Boulder Main Street',
    status: 'installation_scheduled',
    deal_status: 'paid_contract_signed',
    equipment_status: 'fully_fulfilled',
    installation_status: 'installation_scheduled',
    onboarding_status: 'onboarding_info_sent',
    address: '5678 Pearl Street, Boulder, CO 80302',
    phone: '(303) 555-0200',
    logo_url: null,
    contract_signed_date: '2024-10-01',
    contract_renewal_date: '2025-10-01',
    contract_term_months: null,
    contract_signee_name: 'Sarah Johnson',
    contract_signee_title: 'Operations Director',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-12-15',
    launch_date: null,
    monthly_license_fee: 2800.00,
    license_fee_period: 'monthly',
    pos_system: 'Greenbits',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-09-25T10:00:00Z',
    updated_at: '2024-11-18T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '3',
    location_number: 'LOC-003',
    location_name: 'Fort Collins Campus',
    status: 'partially_shipped',
    deal_status: 'paid_contract_signed',
    equipment_status: 'partially_fulfilled',
    installation_status: 'installation_pending',
    onboarding_status: 'onboarding_info_sent',
    address: '9012 College Avenue, Fort Collins, CO 80525',
    phone: '(970) 555-0300',
    logo_url: null,
    contract_signed_date: '2024-11-01',
    contract_renewal_date: '2025-11-01',
    contract_term_months: null,
    contract_signee_name: 'Mike Davis',
    contract_signee_title: 'General Manager',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-12-20',
    launch_date: null,
    monthly_license_fee: 3000.00,
    license_fee_period: 'monthly',
    pos_system: 'Dutchie',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-10-28T10:00:00Z',
    updated_at: '2024-11-19T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '4',
    location_number: 'LOC-004',
    location_name: 'Aspen Mountain',
    status: 'onboarding',
    deal_status: 'active',
    equipment_status: 'equipment_installed',
    installation_status: 'equipment_installed_pending_launch',
    onboarding_status: 'staff_training_scheduled',
    address: '3456 Main Street, Aspen, CO 81611',
    phone: '(970) 555-0400',
    logo_url: null,
    contract_signed_date: '2024-09-15',
    contract_renewal_date: '2025-09-15',
    contract_term_months: null,
    contract_signee_name: 'Emily Chen',
    contract_signee_title: 'Store Owner',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-11-10',
    launch_date: '2024-11-25',
    monthly_license_fee: 3200.00,
    license_fee_period: 'monthly',
    pos_system: 'Leafly',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-09-10T10:00:00Z',
    updated_at: '2024-11-20T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '5',
    location_number: 'LOC-005',
    location_name: 'Colorado Springs Central',
    status: 'renewal_pending',
    deal_status: 'renewal_pending',
    equipment_status: 'equipment_installed',
    installation_status: 'launched_active',
    onboarding_status: 'staff_training_completed',
    address: '7890 Tejon Street, Colorado Springs, CO 80903',
    phone: '(719) 555-0500',
    logo_url: null,
    contract_signed_date: '2023-12-01',
    contract_renewal_date: '2024-12-01',
    contract_term_months: null,
    contract_signee_name: 'Robert Martinez',
    contract_signee_title: 'Regional Manager',
    contract_file_path: null,
    contract_file_url: null,
    monthly_license_fee: 2400.00,
    license_fee_period: 'monthly',
    pos_system: 'Dutchie',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    installation_date: '2024-01-15',
    launch_date: '2024-02-01',
    created_at: '2023-11-25T10:00:00Z',
    updated_at: '2024-11-15T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '6',
    location_number: 'LOC-006',
    location_name: 'Vail Resort',
    status: 'equipment_ordered',
    deal_status: 'paid_contract_signed',
    equipment_status: 'not_yet_ordered',
    installation_status: 'installation_pending',
    onboarding_status: 'onboarding_info_sent',
    address: '1234 Bridge Street, Vail, CO 81657',
    phone: '(970) 555-0600',
    logo_url: null,
    contract_signed_date: '2024-11-10',
    contract_renewal_date: '2025-11-10',
    contract_term_months: null,
    contract_signee_name: 'Lisa Anderson',
    contract_signee_title: 'Store Manager',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2025-01-10',
    launch_date: null,
    monthly_license_fee: 3500.00,
    license_fee_period: 'monthly',
    pos_system: 'Dutchie',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-11-05T10:00:00Z',
    updated_at: '2024-11-18T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '7',
    location_number: 'LOC-007',
    location_name: 'Pueblo West',
    status: 'contract_signed',
    deal_status: 'paid_contract_pending',
    equipment_status: 'not_yet_ordered',
    installation_status: 'installation_pending',
    onboarding_status: 'onboarding_info_sent',
    address: '5678 Highway 50, Pueblo, CO 81007',
    phone: '(719) 555-0700',
    logo_url: null,
    contract_signed_date: '2024-11-20',
    contract_renewal_date: '2025-11-20',
    contract_term_months: null,
    contract_signee_name: 'David Wilson',
    contract_signee_title: 'Owner',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: null,
    launch_date: null,
    monthly_license_fee: 2200.00,
    license_fee_period: 'monthly',
    pos_system: 'Greenbits',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-11-15T10:00:00Z',
    updated_at: '2024-11-20T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
  {
    id: '8',
    location_number: 'LOC-008',
    location_name: 'Steamboat Springs',
    status: 'active',
    deal_status: 'active',
    equipment_status: 'equipment_installed',
    installation_status: 'launched_active',
    onboarding_status: 'staff_training_completed',
    address: '9012 Lincoln Avenue, Steamboat Springs, CO 80487',
    phone: '(970) 555-0800',
    logo_url: null,
    contract_signed_date: '2024-06-01',
    contract_renewal_date: '2025-06-01',
    contract_term_months: null,
    contract_signee_name: 'Jennifer Taylor',
    contract_signee_title: 'Store Manager',
    contract_file_path: null,
    contract_file_url: null,
    installation_date: '2024-07-15',
    launch_date: '2024-08-01',
    monthly_license_fee: 2900.00,
    license_fee_period: 'monthly',
    pos_system: 'Leafly',
    installation_type: null,
    excluded_from_upcoming_launches: false,
    created_at: '2024-05-25T10:00:00Z',
    updated_at: '2024-11-10T10:00:00Z',
    created_by: null,
    updated_by: null,
  },
];

// Mock equipment data
export interface Equipment {
  id: string;
  location_id: string | null;
  purchase_order_id: string | null;
  equipment_type: string;
  size: string | null;
  component_type: string | null;
  serial_number: string;
  model: string | null;
  warranty_date: string | null;
  assignment_status: 'planned' | 'purchased' | 'reserved' | 'assigned' | 'unassigned';
  physical_location: string;
  order_date: string;
  notes: string | null;
}

export const mockEquipment: Equipment[] = [
  {
    id: 'eq-1',
    location_id: '2',
    purchase_order_id: 'po-1',
    equipment_type: 'flower_station',
    size: '27"',
    component_type: null,
    serial_number: 'FS-27-001',
    model: 'Flower Station Pro 27"',
    warranty_date: '2027-11-20',
    assignment_status: 'reserved',
    physical_location: 'Warehouse A',
    order_date: '2024-10-15',
    notes: null,
  },
  {
    id: 'eq-2',
    location_id: null,
    purchase_order_id: null,
    equipment_type: 'category_station',
    size: '21.5"',
    component_type: null,
    serial_number: 'CS-21-045',
    model: 'Category Station 21.5"',
    warranty_date: null,
    assignment_status: 'unassigned',
    physical_location: 'Warehouse B',
    order_date: '2024-09-20',
    notes: null,
  },
  {
    id: 'eq-3',
    location_id: '1',
    purchase_order_id: null,
    equipment_type: 'flower_station',
    size: '27"',
    component_type: null,
    serial_number: 'FS-27-002',
    model: 'Flower Station Pro 27"',
    warranty_date: '2027-03-01',
    assignment_status: 'assigned',
    physical_location: 'Denver Downtown',
    order_date: '2024-01-20',
    notes: null,
  },
  {
    id: 'eq-4',
    location_id: '1',
    purchase_order_id: null,
    equipment_type: 'category_station',
    size: '21.5"',
    component_type: null,
    serial_number: 'CS-21-046',
    model: 'Category Station 21.5"',
    warranty_date: '2027-03-01',
    assignment_status: 'assigned',
    physical_location: 'Denver Downtown',
    order_date: '2024-01-20',
    notes: null,
  },
  {
    id: 'eq-5',
    location_id: null,
    purchase_order_id: null,
    equipment_type: 'quick_checkout',
    size: null,
    component_type: null,
    serial_number: 'QC-001',
    model: 'Quick Checkout Station',
    warranty_date: null,
    assignment_status: 'unassigned',
    physical_location: 'Warehouse A',
    order_date: '2024-10-01',
    notes: null,
  },
  {
    id: 'eq-6',
    location_id: null,
    purchase_order_id: null,
    equipment_type: 'branded_station',
    size: '27"',
    component_type: null,
    serial_number: 'BS-27-001',
    model: 'Branded Station 27"',
    warranty_date: null,
    assignment_status: 'purchased',
    physical_location: 'Warehouse B',
    order_date: '2024-11-01',
    notes: null,
  },
  {
    id: 'eq-7',
    location_id: null,
    purchase_order_id: null,
    equipment_type: 'menu_board',
    size: '55"',
    component_type: null,
    serial_number: 'MB-55-001',
    model: 'Menu Board 55"',
    warranty_date: '2027-11-15',
    assignment_status: 'unassigned',
    physical_location: 'Warehouse A',
    order_date: '2024-11-15',
    notes: null,
  },
];

// Mock shipments data
export interface Shipment {
  id: string;
  records_delivery_only?: boolean;
  location_id: string;
  launch_id: string | null;
  purchase_order_id: string | null;
  creation_source: 'manual' | 'purchase_order_fulfillment' | 'script' | 'migration' | 'unknown';
  created_by: string | null;
  updated_by: string | null;
  shipment_date: string;
  status: 'pending' | 'partially_shipped' | 'shipped' | 'delivered' | 'returned' | 'cancelled';
  tracking_number: string | null;
  carrier: string | null;
  shipment_source: string;
  estimated_delivery_date: string | null;
  actual_delivery_date: string | null;
  ship_to_address: string | null;
  notes: string | null;
}

export const mockShipments: Shipment[] = [
  {
    id: 'ship-1',
    location_id: '3',
    launch_id: null,
    purchase_order_id: null,
    creation_source: 'manual',
    created_by: null,
    updated_by: null,
    shipment_date: '2024-11-15',
    status: 'shipped',
    tracking_number: '1Z999AA10123456784',
    carrier: 'FedEx',
    shipment_source: 'Warehouse A',
    estimated_delivery_date: '2024-11-20',
    actual_delivery_date: null,
    ship_to_address: null,
    notes: 'Partial shipment - remaining items to ship next week',
  },
  {
    id: 'ship-2',
    location_id: '1',
    launch_id: null,
    purchase_order_id: null,
    creation_source: 'manual',
    created_by: null,
    updated_by: null,
    shipment_date: '2024-02-10',
    status: 'delivered',
    tracking_number: '1Z999AA10123456785',
    carrier: 'UPS',
    shipment_source: 'Warehouse A',
    estimated_delivery_date: '2024-02-15',
    actual_delivery_date: '2024-02-14',
    ship_to_address: null,
    notes: 'All equipment delivered and installed',
  },
  {
    id: 'ship-3',
    location_id: '2',
    launch_id: null,
    purchase_order_id: null,
    creation_source: 'manual',
    created_by: null,
    updated_by: null,
    shipment_date: '2024-12-01',
    status: 'shipped',
    tracking_number: null,
    carrier: null,
    shipment_source: 'Warehouse B',
    estimated_delivery_date: '2024-12-10',
    actual_delivery_date: null,
    ship_to_address: null,
    notes: 'Scheduled for December shipment',
  },
];

// Mock purchase orders data
export interface PurchaseOrder {
  id: string;
  po_number: string;
  location_id: string | null;
  launch_id: string | null;
  order_date: string;
  status: 'draft' | 'submitted' | 'approved' | 'purchased' | 'paid' | 'cancelled';
  quickbooks_po_id: string | null;
  quickbooks_sync_date: string | null;
  quickbooks_po_sync_token?: string | null;
  quickbooks_po_realm_id?: string | null;
  quickbooks_po_environment?: 'sandbox' | 'production' | null;
  quickbooks_doc_number?: string | null;
  quickbooks_po_synced_at?: string | null;
  quickbooks_po_last_error?: string | null;
  total_amount: number;
  notes: string | null;
}

export const mockPurchaseOrders: PurchaseOrder[] = [
  {
    id: 'po-1',
    po_number: 'PO-2024-001',
    location_id: '2',
    launch_id: null,
    order_date: '2024-10-15',
    status: 'approved',
    quickbooks_po_id: 'QB-12345',
    quickbooks_sync_date: '2024-10-16',
    total_amount: 15000.00,
    notes: 'Equipment for Boulder location',
  },
  {
    id: 'po-2',
    po_number: 'PO-2024-002',
    location_id: '3',
    launch_id: null,
    order_date: '2024-11-01',
    status: 'submitted',
    quickbooks_po_id: null,
    quickbooks_sync_date: null,
    total_amount: 18000.00,
    notes: 'Equipment for Fort Collins location',
  },
  {
    id: 'po-3',
    po_number: 'PO-2024-003',
    location_id: null,
    launch_id: null,
    order_date: '2024-11-20',
    status: 'draft',
    quickbooks_po_id: null,
    quickbooks_sync_date: null,
    total_amount: 12000.00,
    notes: 'General inventory restock',
  },
];

// Status color mapping using brand colors (legacy)
export const statusColors: Record<LocationStatus, string> = {
  pre_contract_signed: 'bg-gray-100 text-gray-800 border border-gray-200',
  contract_signed: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  equipment_ordered: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  partially_shipped: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  shipment_completed: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  installation_scheduled: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  installed: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  onboarding: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  delayed: 'bg-orange-100 text-orange-800 border border-orange-200',
  cancelled: 'bg-red-100 text-red-800 border border-red-200',
  active: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  renewal_pending: 'bg-amber-100 text-amber-800 border border-amber-200',
  contract_expired: 'bg-red-100 text-red-800 border border-red-200',
};

// New multi-phase status color mappings
export const dealStatusColors: Record<DealStatus, string> = {
  paid_contract_pending: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  paid_contract_signed: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  in_production: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  active: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  renewal_pending: 'bg-amber-100 text-amber-800 border border-amber-200',
  cancelled: 'bg-red-100 text-red-800 border border-red-200',
};

export const equipmentStatusColors: Record<EquipmentStatus, string> = {
  not_yet_ordered: 'bg-gray-100 text-gray-800 border border-gray-200',
  partially_fulfilled: 'bg-amber-100 text-amber-800 border border-amber-200',
  fully_fulfilled: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  equipment_installed: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
};

export const installationStatusColors: Record<InstallationStatus, string> = {
  installation_pending: 'bg-gray-100 text-gray-800 border border-gray-200',
  installation_scheduled: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  equipment_installed_pending_launch: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
  launched_active: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
};

export const onboardingStatusColors: Record<OnboardingStatus, string> = {
  onboarding_info_sent: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  staff_training_scheduled: 'bg-[#6eb5ce]/20 text-[#25495d] border border-[#6eb5ce]/30',
  staff_training_completed: 'bg-[#5ac59a]/20 text-[#25495d] border border-[#5ac59a]/30',
};
